module.exports = __webpack_public_path__ + "img/infra3.e0491935.png";